import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { AccountsPermissions } from './accounts.permissions';

export class AccountsScopesPermissions {
    static GroupName = `${AccountsPermissions.GroupName}.Scopes`;

    static getPermissions = getGroupPermissionFactory(AccountsScopesPermissions.GroupName);

    static Permissions = {
        Assign: AccountsScopesPermissions.getPermissions('Assign'),
        Revoke: AccountsScopesPermissions.getPermissions('Revoke')
    };
}
